import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { UFS } from '@/globals/staticVars.js'
import countries from '@/data/miscData/countries'

let crmUfs = []

for (let uf of UFS) {
  crmUfs.push({
    id: uf.id,
    name: uf.name
  })
}

const formData = {
  'user.name': {
    size: 12,
    type: 'text',
    name: 'user.name',
    label: 'Nome completo*',
    placeholder: 'Digite seu nome completo',
    value: null
  },
  'displayName': {
    size: 6,
    type: 'text',
    name: 'displayName',
    label: 'Nome de exibição*',
    placeholder: 'Seu nome de exibição',
    value: null
  },
  'user.cpf': {
    size: 6,
    type: 'text',
    name: 'user.cpf',
    label: 'CPF*',
    placeholder: '000.000.000-00',
    mask: ['###.###.###-##'],
    value: null
  },
  'user.ddiContactPhone': {
    size: 2,
    type: 'select',
    name: 'user.ddiContactPhone',
    label: 'DDI*',
    placeholder: 'DDI',
    value: null,
    options: countries
  },
  'user.contactPhone': {
    size: 4,
    type: 'text',
    name: 'user.contactPhone',
    label: 'Telefone*',
    mask: ['(##) ####-####', '(##) #####-####'],
    placeholder: 'Digite seu telefone',
    value: null
  },
  'user.gender': {
    size: 4,
    type: 'radio',
    name: 'user.gender',
    label: 'Sexo*',
    wrap: false,
    radios: [
      {
        label: 'Feminino',
        value: 'F'
      },
      {
        label: 'Masculino',
        value: 'M'
      }
    ],
    value: null
  },
  'user.email.first': {
    size: 6,
    type: 'text',
    name: 'user.email',
    label: 'E-mail*',
    placeholder: 'Digite o seu e-mail',
    value: null
  },
  'user.email.second': {
    size: 6,
    type: 'text',
    name: 'user.email',
    label: 'Repetir E-mail*',
    placeholder: 'Digite o seu e-mail novamente',
    value: null,
    errors: {
      samePassword: 'E-mail não confere'
    }
  },
  'user.plainPassword.first': {
    size: 6,
    type: 'password',
    name: 'plainPassword.first',
    label: 'Digite uma senha*',
    value: null,
    hideErrors: true,
    warnings: {
      minLength: ' Deve ter no mínimo 8 caracteres.',
      pwValid: ' Possuir no mínimo um número e uma letra.'
    },
    errors: {
      required: ' '
    }
  },
  'user.plainPassword.second': {
    size: 6,
    type: 'password',
    name: 'plainPassword.second',
    label: 'Repita a senha*',
    value: null,
    errors: {
      samePassword: 'Senhas não conferem'
    }
  },
  crm: {
    size: 4,
    type: 'text',
    mask: '#######',
    name: 'crm',
    label: 'CRM*',
    placeholder: 'Digite o seu CRM',
    loading: 0,
    onChange: true,
    disabled: false,
    value: ''
  },
  crmRegional: {
    size: 2,
    type: 'select',
    name: 'crmRegional',
    label: 'UF*',
    options: crmUfs,
    placeholder: '',
    onChange: true,
    disabled: false,
    value: null
  },
  medicalSpecialty: {
    size: 6,
    type: 'select',
    name: 'medicalSpecialty',
    label: 'Título de especialista*',
    placeholder: 'Selecione um título',
    required: true,
    disabled: true,
    loading: 0,
    onChange: true,
    value: '',
    errors: {
      required: ' '
    },
    options: []
  },
  isCfmValidation: {
    size: 0,
    type: 'hidden',
    name: 'isCfmValidation',
    required: true,
    value: 0,
    class: 'registration__hidden'
  },
  'incomingPartnerName': {
    type: 'hidden',
    required: true,
    value: '',
    class: 'registration__hidden'
  }
}

const requiredFields = [
  'user.name',
  'user.gender',
  'user.email.first',
  'user.email.second',
  'user.contactPhone',
  'medicalSpecialty',
  'user.plainPassword.first',
  'user.plainPassword.second',
  'crmRegional',
  'crm',
  'isCfmValidation'
]

const validations = {}

for (let requiredField of requiredFields) {
  validations[requiredField] = {}
  validations[requiredField].value = {}
  validations[requiredField].value.required = required
}

validations['user.plainPassword.first'] = {
  value: {
    required,
    minLength: minLength(8),
    pwValid: function (value) {
      return this.fn_VALID_PASSWORD(value)
    }
  }
}

validations['user.plainPassword.second'] = {
  value: {
    required,
    samePassword: sameAs(function () {
      return this.formData['user.plainPassword.first'].value
    })
  }
}

validations['user.email.first'] = {
  value: {
    required,
    email
  }
}

validations['user.email.second'] = {
  value: {
    required,
    samePassword: sameAs(function () {
      return this.formData['user.email.first'].value
    })
  }
}

validations['crm'] = {
  value: { required }
}

validations['user.ddiContactPhone'] = {
  value: { required }
}

validations['user.contactPhone'] = {
  value: {
    required,

    isValid (value) {
      if (value) {
        const iso = this.formData['user.ddiContactPhone'].value
        return isValidPhoneNumber(value, String(iso.toUpperCase()))
      }

      return true
    }
  }
}

validations['user.cpf'] = {
  value: {
    required,

    isValid (value) {
      return this.fn_VALID_CPF(value)
    }
  }
}

export { formData, validations }
